var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      staticClass: "seedfarm-accept-modal",
      attrs: { title: "认可关系详情", "mask-closable": false, width: "900" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("h3", { staticClass: "section-title" }, [_vm._v("基本信息")]),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("客户经理编号：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.detailData.userCustomerManagerCode)),
                      ]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("客户经理姓名：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.detailData.userCustomerManagerName)),
                      ]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c(
                      "div",
                      { staticClass: "info-item" },
                      [
                        _c("label", [_vm._v("认可状态：")]),
                        _c(
                          "Tag",
                          {
                            attrs: {
                              color: _vm.getStatusColor(
                                _vm.detailData.recordStatus
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getStatusText(_vm.detailData.recordStatus)
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("苗场编号：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.seedFarmCode))]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("苗场名称：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.seedFarmName))]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("创建人：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.creatorName))]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("创建人编号：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.creatorCode))]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("修改人：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.modifierName))]),
                    ]),
                  ]),
                  _c("Col", { attrs: { span: "8" } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("修改人编号：")]),
                      _c("span", [_vm._v(_vm._s(_vm.detailData.modifierCode))]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("Divider"),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [_c("Button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }